import styled, { css } from "styled-components"
import { minWidth } from "utils"
import Icon from "icons"

export const Container = styled.div`
  margin-bottom: 2.5rem;
  display: none;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.17;
  text-transform: uppercase;
  letter-spacing: 0.2rem;

  ${minWidth.tablet`
    flex-direction: row;
    display: flex;
  `}
`

export const Left = styled.a`
  margin-right: 1rem;
  display: flex;
  align-items: center;
  color: #b5471f;
`

export const Right = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  color: #767676;

  ${minWidth.tablet`
    margin-top: 0;
  `}
`

export const VerticalPipe = styled.span`
  margin-right: 1rem;
  display: none;

  ${minWidth.tablet`
    display: block;
  `}
`

const icon = css`
  margin-left: 0.8rem;
`

export const PersonSvg = styled(Icon)`
  ${icon}
`

export const CheckSmallSvg = styled(Icon)`
  ${icon}
`

export const PlusSvg = styled(Icon)`
  ${icon}
`
